<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-settings">{{
              $t("dashboardCardSuperAdminBasicSettings")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <v-form ref="form" v-model="valid">
              <!-- MODULE SETTINGS -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  <span class="headline">{{
                    $t("settingsPhotoOrderBasicSettingsTitle")
                  }}</span>
                </v-card-title>
                <v-card-text class="pb-0 mb-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.notifyEmail"
                        :label="$t('settingsNotifyEmailText')"
                        :rules="[validateIsEmail(), validateMaxLength(250)]"
                        :counter="250"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.taxPct"
                        :label="$t('settingsPhotoOrderBasicTaxTitle')"
                        :rules="[
                          validateRequired(),
                          validateIsPercent(),
                          validateMaxLength(3),
                        ]"
                        :counter="3"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.extraCharge"
                        :label="$t('settingsDeliveryGridHeaderExtraPayTitle')"
                        :rules="[
                          validateRequired(),
                          validateIsCurrency(),
                          validateMaxLength(20),
                        ]"
                        :counter="20"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.extraChargeMessage"
                        :label="
                          $t('settingsDeliveryGridHeaderExtraPayMessageTitle')
                        "
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.extraChargeFreeOver"
                        :label="
                          $t('settingsDeliveryGridHeaderExtraPayFreeOverTitle')
                        "
                        :rules="[
                          validateRequired(),
                          validateIsCurrency(),
                          validateMaxLength(20),
                        ]"
                        :counter="20"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.minOrder"
                        :label="$t('settingsDeliveryGridHeaderMinOrderTitle')"
                        :rules="[
                          validateRequired(),
                          validateIsCurrency(),
                          validateMaxLength(20),
                        ]"
                        :counter="20"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch
                        dense
                        style="height: 30px"
                        class="ma-0 pa-0"
                        v-model="editedItem.enableAdvancedUpload"
                        :label="
                          $t('settingsPhotoOrderBasicEnableAdvancedUploadTitle')
                        "
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch
                        dense
                        style="height: 50px"
                        class="ma-0 pa-0"
                        v-model="editedItem.enableSimpleUpload"
                        :label="
                          $t('settingsPhotoOrderBasicEnableSimpleUploadTitle')
                        "
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch
                        dense
                        style="height: 50px"
                        class="ma-0 pa-0"
                        v-model="editedItem.keepOriginalFileNames"
                        :label="
                          $t('settingsPhotoOrderBasicKeepOriginalFileNames')
                        "
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch
                        dense
                        style="height: 30px"
                        class="ma-0 pa-0"
                        v-model="editedItem.enableDate"
                        :label="
                          $t('settingsPhotoOrderBasicEnableDateTitle')
                        "
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch
                        dense
                        style="height: 50px"
                        class="ma-0 pa-0"
                        v-model="editedItem.enableCrop"
                        :label="
                          $t('settingsPhotoOrderBasicEnableCropTitle')
                        "
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- basicSettings -->
              <v-card
                class="#505050--text mb-1"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; background-color: white'
                    : 'border: none; background-color: white'
                "
              >
                <v-card-title>
                  <span class="headline">{{
                    $t("settingsPhotoOrderBasicApperanceTitle")
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-switch
                        class="ma-0 pa-0"
                        style="height: 30px"
                        v-model="editedItem.show"
                        :label="$t('msgShow')"
                        dense
                      ></v-switch>
                      <v-switch
                        class="ma-0 pa-0"
                        style="height: 50px"
                        v-model="editedItem.whiteText"
                        :label="$t('settingsPhotoOrderBasicWhiteText')"
                        dense
                      ></v-switch>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.title"
                        :label="$t('settingsPhotoOrderBasicTitle')"
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-text-field
                        class="mb-3"
                        v-model="editedItem.subtitle"
                        :label="$t('settingsPhotoOrderBasicSubTitle')"
                        :rules="[validateMaxLength(100)]"
                        :counter="100"
                        dense
                      ></v-text-field>
                      <v-file-input
                        v-bind:clearable="false"
                        accept="image/jpeg"
                        prepend-icon="mdi-camera"
                        append-icon="mdi-close"
                        @change="fileMenuImageChange()"
                        @click:append="fileMenuImageRemove()"
                        v-model="fileMenuImage"
                        class="mb-3 mt-0 pa-0"
                        :label="$t('settingsPhotoOrderBasicImage')"
                      ></v-file-input>
                      <v-img
                        :src="
                          editedItem.menuImage.length > 0
                            ? editedItem.menuImage
                            : cardMenuImage
                        "
                        class="mb-6"
                        style="max-width: 600px"
                      ></v-img>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuModulePhotoOrder' })"
          ></simple-navigation-button>
          <!-- GUMB SHRANI -->
          <simple-navigation-button
            right
            :title="$t('addEditFormSaveButton')"
            icon="mdi-content-save"
            @clicked="saveForm"
          ></simple-navigation-button>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import { storage } from "@/firebase";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

export default {
  name: "settingsPhotoOrderBasic",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      cardMenuImage: require("@/assets/usersNewOrder.jpg"),
      editedItem: {
        show: this.$store.state.storeClient.client.modules.modulePhotoOrder
          .show,
        whiteText:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .whiteText,
        title:
          this.$store.state.storeClient.client.modules.modulePhotoOrder.title,
        subtitle:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .subtitle,
        menuImage:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .menuImage,
        notifyEmail:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .notifyEmail,
        taxPct:
          this.$store.state.storeClient.client.modules.modulePhotoOrder.taxPct,
        extraCharge:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .extraCharge,
        extraChargeFreeOver:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .extraChargeFreeOver,
        minOrder:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .minOrder,
        extraChargeMessage:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .extraChargeMessage,
        enableSimpleUpload:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .enableSimpleUpload,
        enableAdvancedUpload:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .enableAdvancedUpload,
        keepOriginalFileNames:
          this.$store.state.storeClient.client.modules.modulePhotoOrder
            .keepOriginalFileNames,
        enableDate: this.$store.state.storeClient.client.modules.modulePhotoOrder.enableDate,
        enableCrop: this.$store.state.storeClient.client.modules.modulePhotoOrder.enableCrop,
      },
      fileMenuImage: [],
    };
  },
  methods: {
    fileMenuImageChange() {
      if (this.fileMenuImage != null) {
        let uploadPath =
          "clientCustomData/" +
          this.$store.state.storeClient.client.basicSettings.name +
          "ModPhotoOrderMainImage.jpg";
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(this.fileMenuImage);
        let vm = this;
        let theURL = "";

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                theURL = downloadURL;
                vm.$store.dispatch("saveSettingsCustomModuleMainImage", {
                  modules: {
                    modulePhotoOrder: {
                      menuImage: theURL,
                    },
                  },
                });
                vm.editedItem.menuImage = theURL;
              });
          },
        });
      } else {
        this.$store.dispatch("saveSettingsCustomModuleMainImage", {
          modules: {
            modulePhotoOrder: {
              menuImage: "",
            },
          },
        });
        this.editedItem.menuImage = "";
      }
    },
    fileMenuImageRemove() {
      this.$store.dispatch("saveSettingsCustomModuleMainImage", {
        modules: {
          modulePhotoOrder: {
            menuImage: "",
          },
        },
      });
      this.editedItem.menuImage = "";
    },
    async saveForm() {
      if (this.$refs.form.validate()) {
        try {
          let result = await this.$store.dispatch(
            "saveSettingsCustomModuleMainImage",
            {
              modules: {
                modulePhotoOrder: {
                  show: this.editedItem.show,
                  whiteText: this.editedItem.whiteText,
                  title: this.editedItem.title,
                  subtitle: this.editedItem.subtitle,
                  notifyEmail: this.editedItem.notifyEmail,
                  taxPct: this.editedItem.taxPct,
                  extraCharge: this.editedItem.extraCharge,
                  extraChargeFreeOver: this.editedItem.extraChargeFreeOver,
                  minOrder: this.editedItem.minOrder,
                  extraChargeMessage: this.editedItem.extraChargeMessage,
                  enableSimpleUpload: this.editedItem.enableSimpleUpload,
                  enableAdvancedUpload: this.editedItem.enableAdvancedUpload,
                  keepOriginalFileNames: this.editedItem.keepOriginalFileNames,
                  enableDate: this.editedItem.enableDate,
                  enableCrop: this.editedItem.enableCrop,
                },
              },
            }
          );
          if (result) {
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } else {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("msgErrorSave"),
            });
          }
        } catch (error) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: error,
          });
        }
      }
    },
  },
};
</script>
